import { createContext, useContext, useEffect, useState } from "react";

const SYMBOL = { EUR: "€", USD: "$", GBP: "£", CHF: "CHF" };
const CCtx = createContext({ currency: "EUR", setCurrency: () => {}, rates: { EUR: 1 }, convert: (n) => n, format: (n) => n });

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem("hh_ccy") || "EUR");
  const [rates, setRates] = useState({ EUR: 1 });
  const [ready, setReady] = useState(false);
  useEffect(() => { localStorage.setItem("hh_ccy", currency); }, [currency]);
  useEffect(() => {
    let cancelled = false;
    fetch("https://api.frankfurter.dev/v1/latest?base=EUR&symbols=USD,GBP,CHF")
      .then((r) => r.json())
      .then((d) => { if (!cancelled) { setRates({ EUR: 1, ...(d.rates || {}) }); setReady(true); } })
      .catch(() => { if (!cancelled) setReady(false); });
    return () => { cancelled = true; };
  }, []);
  const convert = (eur) => Number(eur) * (rates[currency] || 1);
  const format = (eur, opts = {}) => {
    const active = currency !== "EUR" && !ready ? "EUR" : currency;
    const val = Number(eur) * (rates[active] || 1);
    const digits = opts.digits ?? (val >= 100 ? 0 : 2);
    return `${SYMBOL[active] || active} ${val.toFixed(digits)}`;
  };
  return <CCtx.Provider value={{ currency, setCurrency, rates, convert, format, ready }}>{children}</CCtx.Provider>;
}

export const useCurrency = () => useContext(CCtx);
export const CURRENCIES = ["EUR", "USD", "GBP", "CHF"];
